import { PayloadAction, createSelector, createSlice } from '@reduxjs/toolkit';
import { SpendAmount } from '../budget-optimiser/budget-optimiser.types';
import { queryApi } from 'app/apis/queryApi';
import { RootState } from 'app/store';
import { selectSite } from 'features/topbar/selectedSiteSlice';
import { PURGE } from 'redux-persist';

const initialState = {
  spendAmounts: [] as SpendAmount[],
  selectedSegmentKey: ''
};

const mmmHeaderControlsSlice = createSlice({
  name: 'mmmHeaderControls',
  initialState,
  reducers: {
    onSpendAmountChanged: (
      state,
      newSpendAmount: PayloadAction<SpendAmount>
    ) => {
      const newSpendAmounts = state.spendAmounts
        .filter((sa) => sa.segmentKey === state.selectedSegmentKey)
        .map<SpendAmount>((spendAmount) =>
          spendAmount.sourceCategoryName ===
          newSpendAmount.payload.sourceCategoryName
            ? newSpendAmount.payload
            : spendAmount
        );

      const otherSpendAmounts = state.spendAmounts.filter(
        (sa) => sa.segmentKey !== state.selectedSegmentKey
      );

      state.spendAmounts = [...newSpendAmounts, ...otherSpendAmounts];
    },
    onSegmentChanged: (state, newSegmentKey: PayloadAction<string>) => {
      state.selectedSegmentKey = newSegmentKey.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(selectSite, (state, action) => {
      state = initialState;
    });
    builder.addCase(PURGE, () => initialState);
    builder.addMatcher(
      queryApi.endpoints.getDataScienceMmmSegmentData.matchFulfilled,
      (state, mmmModelOutput) => {
        const spendAmounts = mmmModelOutput.payload.forecasts.map<SpendAmount>(
          (forecast) => {
            return {
              sourceCategoryName: forecast.sourceCategoryDisplayName,
              optimisedSpendAmount:
                forecast.optimisedSpend === 0
                  ? forecast.maximumRealSpend
                  : forecast.optimisedSpend,
              maximumSpend: forecast.maximumForecastSpend,
              segmentKey: mmmModelOutput.meta.arg.originalArgs.segment
            };
          }
        );

        state.spendAmounts = [...state.spendAmounts, ...spendAmounts];
      }
    );
    builder.addMatcher(
      queryApi.endpoints.getDataScienceMmmSegments.matchFulfilled,
      (state, segments: PayloadAction<string[]>) => {
        if (segments.payload.length > 0) {
          const selectedSegmentKey =
            state.selectedSegmentKey.length < 1
              ? segments.payload[0]
              : state.selectedSegmentKey;

          state.selectedSegmentKey = selectedSegmentKey;
        }
      }
    );
  }
});

export const getSpendAmounts = createSelector(
  (state: RootState) => state.mmmHeaderControls,
  (state) =>
    state.spendAmounts.filter(
      (sa) => sa.segmentKey === state.selectedSegmentKey
    )
);

const { actions, reducer } = mmmHeaderControlsSlice;

export const { onSpendAmountChanged, onSegmentChanged } = actions;

export default reducer;
